module.exports = __webpack_public_path__ + "img/sex-man.11c60f8e.svg";